export default {"src":"/_next/static/media/chartwrapper.7b3d4ac8.svg","height":366,"width":700,"blurWidth":0,"blurHeight":0};